export const FETCH_PAYMENT_PRODUCTS_REQUEST = 'FETCH_PAYMENT_PRODUCTS_REQUEST';
export const FETCH_PAYMENT_PRODUCTS_SUCCESS = 'FETCH_PAYMENT_PRODUCTS_SUCCESS';
export const FETCH_PAYMENT_PRODUCTS_FAILURE = 'FETCH_PAYMENT_PRODUCTS_FAILURE';

export const POST_PAYMENT_ORDER_REQUEST = 'POST_PAYMENT_ORDER_REQUEST';
export const POST_PAYMENT_ORDER_SUCCESS = 'POST_PAYMENT_ORDER_SUCCESS';
export const POST_PAYMENT_ORDER_FAILURE = 'POST_PAYMENT_ORDER_FAILURE';

export const UPDATE_PAYMENT_ORDER_REQUEST = 'UPDATE_PAYMENT_ORDER_REQUEST';
export const UPDATE_PAYMENT_ORDER_SUCCESS = 'UPDATE_PAYMENT_ORDER_SUCCESS';
export const UPDATE_PAYMENT_ORDER_FAILURE = 'UPDATE_PAYMENT_ORDER_FAILURE';

export const FETCH_PAYMENT_ORDER_REQUEST = 'FETCH_PAYMENT_ORDER_REQUEST';
export const FETCH_PAYMENT_ORDER_SUCCESS = 'FETCH_PAYMENT_ORDER_SUCCESS';
export const FETCH_PAYMENT_ORDER_FAILURE = 'FETCH_PAYMENT_ORDER_FAILURE';

export const FETCH_PAYMENT_CLIENT_SECRET_REQUEST = 'FETCH_PAYMENT_CLIENT_SECRET_REQUEST';
export const FETCH_PAYMENT_CLIENT_SECRET_SUCCESS = 'FETCH_PAYMENT_CLIENT_SECRET_SUCCESS';
export const FETCH_PAYMENT_CLIENT_SECRET_FAILURE = 'FETCH_PAYMENT_CLIENT_SECRET_FAILURE';

export const POST_PAYMENT_PAY_REQUEST = 'POST_PAYMENT_PAY_REQUEST';
export const POST_PAYMENT_PAY_SUCCESS = 'POST_PAYMENT_PAY_SUCCESS';
export const POST_PAYMENT_PAY_FAILURE = 'POST_PAYMENT_PAY_FAILURE';

export const POST_PAYMENT_INVOICE_REQUEST = 'POST_PAYMENT_INVOICE_REQUEST';
export const POST_PAYMENT_INVOICE_SUCCESS = 'POST_PAYMENT_INVOICE_SUCCESS';
export const POST_PAYMENT_INVOICE_FAILURE = 'POST_PAYMENT_INVOICE_FAILURE';

export const PAYMENT_SET_ACTIVE_STEP = 'PAYMENT_SET_ACTIVE_STEP';
export const PAYMENT_SET_METHOD = 'PAYMENT_SET_METHOD';
export const PAYMENT_SET_IS_UPDATING = 'PAYMENT_SET_IS_UPDATING';
export const PAYMENT_RESET_FLOW = 'PAYMENT_RESET_FLOW';
export const PAYMENT_CANCEL_CHECKOUT = 'PAYMENT_CANCEL_CHECKOUT';

export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILURE = 'FETCH_ORDERS_FAILURE';
